module.exports = "<p-dropdown [style]=\"{'width':'250px'}\" [options]=\"company_list\" [(ngModel)]=\"existCompany\" (onChange)=\"onCompanySelected($event)\"></p-dropdown>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/company-drop-down-list/company-drop-down-list.component.html
// module id = ./src/app/component/company-drop-down-list/company-drop-down-list.component.html
// module chunks = main